import GlobalVials from "./GlobalVials";

export default GlobalVials;